import React, { useState, useEffect } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getApp, getApps, initializeApp } from 'firebase/app';
import { getCtData, getStlValues } from '../../../project';
import { waitForUserData } from '../actions/waitForUserData';
import { useData } from '../../../..';

// 🔥 Configuração do Firebase
const firebaseConfig = {
  apiKey: 'AIzaSyBJ1MNdqlCOmPXK3taPtmuEJbsrmtiUDxU',
  authDomain: 'goodbike-cd338.firebaseapp.com',
  projectId: 'goodbike-cd338',
  storageBucket: 'goodbike-cd338.appspot.com',
  messagingSenderId: '177294326394',
  appId: '1:177294326394:web:00671a5c16846c33e499c3',
};

// 🛠️ Garantir que o Firebase só será inicializado uma vez
// const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
const fbInit = initializeApp(firebaseConfig);
const auth = getAuth(fbInit);

export const WebComp = () => {
  const [user, setUser] = useState(null);

  const btn = async () => {
    try {
      const provider = new GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');

      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      setUser(user);

      const userLogin = {
        userData: {
          email: user.email,
          name: user.displayName,
          image: user.photoURL,
        },
      };

      await waitForUserData(userLogin, fbInit);
    } catch (error) {
      console.error('Erro ao autenticar:', error.message);
    }
  };

  // ---------- set Caps Inputs
  const arrStyles = [
    { backgroundColor: getCtData('all.colors.deepPurple') },
    { alignItems: 'center' },
    { justifyContent: 'center' },
    { borderRadius: 20 },
    { paddingHorizontal: 32 },
    { paddingVertical: 8 },
  ];

  // ---------- set Styles
  const stl = getStlValues(arrStyles);

  const allProps = {
    style: [stl],
    onPress: btn,
  };

  return (
    <View style={styles.container}>
      {user ? (
        <Text>Bem-vindo, {user.displayName}</Text>
      ) : (
        <Pressable {...allProps}>
          <Text style={{ color: 'white' }}>Login com Google</Text>
        </Pressable>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
